export default Object.freeze([
  'Психологическая',
  'Медицинская',
  'Социальная',
  'Юридическая',
])
